@let legalData = metaData()['legalData'];

<form [formGroup]="form">
    <app-website-config-form-expansion-panel [title]="'Impressum'">
        <div formGroupName="imprint">

            <div class="admin-row no-border-bottom add-margins">
                <mat-slide-toggle formControlName="useImprintTemplate" labelPosition="before">Vorlage verwenden</mat-slide-toggle>
            </div>

            @if (form.get('imprint.useImprintTemplate')?.value) {
                <p class="admin-text headline">Verantwortlich für den Inhalt</p>
                @for (field of fieldsContentManager; let index = $index; track $index) {
                <div [formGroupName]="field.key">
                    <div class="admin-row no-border-bottom">
                        <div class="sub-cell">
                            <mat-form-field class="table-width" appearance="outline">
                                <mat-label>{{ field.label }}</mat-label>
                                <input matInput [placeholder]="field.placeholder" formControlName="value">
                                @if (field.errorKey && form.get(['imprint', field.key,
                                'value'])?.hasError(field.errorKey) && form.get(['imprint', field.key,
                                'value'])?.touched) {
                                <mat-error>{{ field.errorMessage }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="sub-cell">
                            <mat-checkbox formControlName="syncWithContactData"
                                (change)="toggleInput('imprint.' + field.key)">
                                Mit Unternehmensdaten synchronisieren
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                }

            }
            @else {
            <app-admin-user-input [editorContent]="legalData.customImprintContent || ''"
                (onEditorContentSaved)="saveCustomImprintContent($event)"></app-admin-user-input>
            }
        </div>
    </app-website-config-form-expansion-panel>

    <app-website-config-form-expansion-panel [title]="'Datenschutzerklärung'">
        <div formGroupName="dataPrivacy">

            <div class="admin-row no-border-bottom add-margins">
                <mat-slide-toggle formControlName="useDataPrivacyTemplate" labelPosition="before">Vorlage
                    verwenden</mat-slide-toggle>
            </div>

            @if (form.get('dataPrivacy.useDataPrivacyTemplate')?.value) {

                <p class="admin-text headline">Verantwortlich für den Inhalt</p>
                @for (field of fieldsDataPrivacyManager; let index = $index; track $index) {
                <div [formGroupName]="field.key">
                    <div class="admin-row no-border-bottom">
                        <div class="sub-cell">
                            <mat-form-field class="table-width" appearance="outline">
                                <mat-label>{{ field.label }}</mat-label>
                                <input matInput [placeholder]="field.placeholder" formControlName="value">
                                @if (field.errorKey && form.get(['dataPrivacy', field.key,
                                'value'])?.hasError(field.errorKey) && form.get(['dataPrivacy', field.key,
                                'value'])?.touched) {
                                <mat-error>{{ field.errorMessage }}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div class="sub-cell">
                            <mat-checkbox formControlName="syncWithContactData"
                                (change)="toggleInput('dataPrivacy.' + field.key)">
                                Mit Unternehmensdaten synchronisieren
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                }

            }
            @else {
            <app-admin-user-input [editorContent]="legalData.customDataPrivacyContent || ''"
                (onEditorContentSaved)="saveCustomDataPrivacyContent($event)"></app-admin-user-input>
            }
        </div>
    </app-website-config-form-expansion-panel>
</form>